export default {
  alloyfactorLimitsLabel: 'Limity faktora zliatiny',
  alloyFactorCFerrite: 'Faktor zliatiny C (ferit)',
  alloyFactorCAustenite: 'Faktor zliatiny C (austenit)',
  alloyFactorNFerrite: 'Faktor zliatiny N (ferit)',
  alloyFactorNAustenite: 'Faktor zliatiny N (austenit)',
  activityCoefficients: 'Koeficienty aktivity',
};
